import { useMutation, useQueryClient } from '@tanstack/react-query'
import { aiStudioService, UpdateGarmentInfoParams } from '../../../service/aiStudio'
import { UserFile } from '../../../service/user'

export interface UseUpdateGarmentInfoParams {
  imageId: number
  params: UpdateGarmentInfoParams
}

export const useUpdateGarmentInfo = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ imageId, params }: UseUpdateGarmentInfoParams) => {
      const response = await aiStudioService.updateGarmentInfo(imageId, params)
      return response
    },
    onSuccess: (data, variables) => {
      // 관련된 캐시 무효화
      queryClient.invalidateQueries({ 
        queryKey: ['user', 'files'] 
      })
      queryClient.invalidateQueries({ 
        queryKey: ['ai-studio', 'upload', variables.imageId] 
      })
    },
    onError: (error) => {
      console.error('의류 정보 업데이트 실패:', error)
    },
  })
}